// import React from "react";
// import "./metrics.css";
// import { useRef } from "react";

// // Import your SVG card images
// import card1 from "../../img/des_sec/metrics_1.svg";
// import card2 from "../../img/des_sec/metrics_2.svg";
// import card3 from "../../img/des_sec/metrics_3.svg";
// import card4 from "../../img/des_sec/metrics_4.svg";
// import card5 from "../../img/des_sec/metrics_5.svg";

// function MetricsSection() {
//   const sliderRef = useRef(null);
  
//   const scrollLeft = () => {
//     if (sliderRef.current) {
//       sliderRef.current.scrollBy({ left: -200, behavior: 'smooth' });
//     }
//   };
  
//   const scrollRight = () => {
//     if (sliderRef.current) {
//       sliderRef.current.scrollBy({ left: 200, behavior: 'smooth' });
//     }
//   };

//   return (
//     <div className="metrics-container-mt">
//       <h2 className="metrics-title-mt">The Metrics <span className="metrics-title2-mt">That Matter</span></h2>
      
//       <div className="metrics-slider-container">
//         <button className="slider-arrow left-arrow" onClick={scrollLeft}>&lt;</button>
        
//         <div className="metrics-grid-mt" ref={sliderRef}>
//           <img src={card1} alt="<5 Minutes Onboarding" className="metric-card-mt" />
//           <img src={card2} alt="10X Faster Compliance" className="metric-card-mt" />
//           <img src={card3} alt="60% Faster Deployment" className="metric-card-mt" />
//           <img src={card4} alt="30% Cost Savings" className="metric-card-mt" />
//           <img src={card5} alt="100% Accuracy" className="metric-card-mt" />
//         </div>
        
//         <button className="slider-arrow right-arrow" onClick={scrollRight}>&gt;</button>
//       </div>
//     </div>
//   );
// }

// export default MetricsSection;

import React, { useRef } from "react";
import "./metrics.css";
import { useSpring, useTrail, animated } from "@react-spring/web";
import { useInView } from "react-intersection-observer";

// Import your SVG card images
import card1 from "../../img/des_sec/metrics_1.svg";
import card2 from "../../img/des_sec/metrics_2.svg";
import card3 from "../../img/des_sec/metrics_3.svg";
import card4 from "../../img/des_sec/metrics_4.svg";
import card5 from "../../img/des_sec/metrics_5.svg";

function MetricsSection() {
  const sliderRef = useRef(null);

  // Detect when component is in view
  const { ref, inView } = useInView({
    triggerOnce: false, // Allow animations to replay if component leaves and re-enters viewport
    threshold: 0.3, // Trigger when 30% of component is visible
  });

  // Animation for title (fade-in and slide-up)
  const titleProps = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? "translateY(0)" : "translateY(30px)",
    config: { tension: 150, friction: 30 }, // Slower, smoother animation
    delay: 200,
  });

  // Animation for slider arrows (fade-in and scale-up)
  const arrowProps = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? "scale(1)" : "scale(0.8)",
    config: { tension: 150, friction: 30 }, // Slower, smoother animation
    delay: 400,
  });

  // Animation for metric cards (staggered fade-in and slide-up)
  const cards = [card1, card2, card3, card4, card5];
  const trail = useTrail(cards.length, {
    opacity: inView ? 1 : 0,
    transform: inView ? "translateY(0)" : "translateY(20px)",
    config: { mass: 1, tension: 1500, friction: 120 }, // Slower, smoother staggered effect
    delay: 600,
  });

  const scrollLeft = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: -200, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: 200, behavior: "smooth" });
    }
  };

  return (
    <div className="metrics-container-mt" ref={ref}>
      <animated.h2 className="metrics-title-mt" style={titleProps}>
        The Metrics <span className="metrics-title2-mt">That Matter</span>
      </animated.h2>

      <div className="metrics-slider-container">
        <animated.button
          className="slider-arrow left-arrow"
          onClick={scrollLeft}
          style={arrowProps}
        >
          &lt;
        </animated.button>

        <div className="metrics-grid-mt" ref={sliderRef}>
          {trail.map((props, index) => (
            <animated.img
              key={index}
              src={cards[index]}
              alt={`Metric ${index + 1}`}
              className="metric-card-mt"
              style={props}
            />
          ))}
        </div>

        <animated.button
          className="slider-arrow right-arrow"
          onClick={scrollRight}
          style={arrowProps}
        >
          &gt;
        </animated.button>
      </div>
    </div>
  );
}

export default MetricsSection;